import RESTApiEndPoints from "@/services/rest-api-end-points";
import IEpmdData from "@/models/epmd-data";
import ISearchRequest from "@/models/SearchRequest";
import IEpmdHeader from "@/models/epmd-header";
import axiosService from "@/services/axios-service";
import ISyncEPMDData from "@/models/ISyncEPMDData";

export default class EPMDService {
  public async GetHeader(epmdType: number, wasteLevel: number): Promise<IEpmdHeader[]> {
    const result = await axiosService.get<IEpmdHeader[]>(
      RESTApiEndPoints.epmdHeaderUrl() + epmdType + "/" + wasteLevel
    );
    return result.data;
  }

  public async Lock(id: string) {
    return axiosService.get(`${RESTApiEndPoints.epmdUrl()}lock/${id}`);
  }

  public async UnLock(id: string) {
    return axiosService.get(`${RESTApiEndPoints.epmdUrl()}unlock/${id}`);
  }

  public async GetData(
    epmdType: number,
    wasteLevel: number,
    searchRequest: ISearchRequest
  ): Promise<IEpmdData[]> {
    const result = await axiosService.post<IEpmdData[]>(
      RESTApiEndPoints.epmdDataUrl() + epmdType + "/" + wasteLevel,
      searchRequest
    );
    return result.data;
  }

  public async GetSyncData(
    epmdType: number,
    wasteLevel: number,
    searchRequest: ISearchRequest
  ): Promise<ISyncEPMDData> {
    const result = await axiosService.post<ISyncEPMDData>(
      RESTApiEndPoints.epmdSyncUrl() + epmdType + "/" + wasteLevel,
      searchRequest
    );
    return result.data;
  }

  public async GetExcelData(
    epmdType: number,
    wasteLevel: number,
    searchRequest: ISearchRequest
  ): Promise<IEpmdData[]> {
    const result = await axiosService.post(
      RESTApiEndPoints.epmdUrl() + "GetEPMDExcel" + "/" + epmdType + "/" + wasteLevel,
      searchRequest,
      {
        responseType: "blob"
      }
    );
    return result.data;
  }

  public async GetPdfData(
    epmdType: number,
    wasteLevel: number,
    searchRequest: ISearchRequest
  ): Promise<IEpmdData[]> {
    const result = await axiosService.post(
      RESTApiEndPoints.epmdUrl() + "GetEPMDPdf" + "/" + epmdType + "/" + wasteLevel,
      searchRequest,
      {
        responseType: "blob"
      }
    );
    return result.data;
  }
}
